import React, { useEffect, useRef, useState } from "react";
import { createPortal } from "react-dom";
import { useOverlayPortal } from "../lib/overlayPortal";

/* 轻量右键菜单：useContextMenu() → bind(items) 给行元素（仅鼠标右键；不做手机长按），element 渲染一次即可 */
export const ContextMenu = ({ x, y, items, onClose, tid = "ctx-menu" }) => {
  const portal = useOverlayPortal(); // 沟通窗的右键操作留在其顶层，其他页面不改变挂载位置。
  const ref = useRef(null);
  const [pos, setPos] = useState({ x, y });
  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    const r = el.getBoundingClientRect();
    setPos({ x: Math.min(x, window.innerWidth - r.width - 8), y: Math.min(y, window.innerHeight - r.height - 8) });
  }, [x, y]);
  useEffect(() => {
    const down = (e) => { if (ref.current && !ref.current.contains(e.target)) onClose(); };
    const key = (e) => { if (e.key === "Escape") onClose(); };
    const t = setTimeout(() => { document.addEventListener("mousedown", down); document.addEventListener("touchstart", down); document.addEventListener("scroll", onClose, true); }, 0);
    document.addEventListener("keydown", key);
    return () => { clearTimeout(t); document.removeEventListener("mousedown", down); document.removeEventListener("touchstart", down); document.removeEventListener("scroll", onClose, true); document.removeEventListener("keydown", key); };
  }, [onClose]);
  const list = (items || []).filter(Boolean);
  return createPortal(
    <div ref={ref} role="menu" data-testid={tid} className="fixed z-[10050] min-w-[180px] rounded-xl border border-slate-200 bg-white shadow-2xl p-1 text-xs animate-in fade-in zoom-in-95 duration-100" style={{ left: pos.x, top: pos.y }} onContextMenu={(e) => e.preventDefault()}>
      {list.map((it, i) => it.sep ? <div key={`s${i}`} className="my-1 border-t border-slate-100" /> : (
        <button key={it.key || i} type="button" role="menuitem" disabled={it.disabled} data-testid={`${tid}-${it.key || i}`}
          onClick={(e) => { e.stopPropagation(); onClose(); it.onClick?.(); }}
          className={`w-full flex items-center gap-2 px-2.5 py-1.5 rounded-lg text-left disabled:opacity-40 ${it.danger ? "text-red-600 hover:bg-red-50" : "text-slate-700 hover:bg-slate-100"}`}>
          {it.icon && <it.icon className="h-3.5 w-3.5 shrink-0" />}<span className="flex-1 truncate">{it.label}</span>{it.hint && <span className="text-[10px] text-slate-400">{it.hint}</span>}
        </button>
      ))}
    </div>, portal || document.body);
};

export const useContextMenu = (tid) => {
  const [menu, setMenu] = useState(null);
  const openAt = (x, y, items) => setMenu({ x, y, items: typeof items === "function" ? items() : items });
  const bind = (items) => ({
    onContextMenu: (e) => { e.preventDefault(); e.stopPropagation(); openAt(e.clientX, e.clientY, items); },
  });
  const close = () => setMenu(null);
  const element = menu ? <ContextMenu {...menu} tid={tid} onClose={close} /> : null;
  return { bind, element, close, open: menu !== null };
};
